import { configureStore } from '@reduxjs/toolkit'
import callDetailsSlice from './CallDetails/callDetailsSlice'
import adminVarSlice from './AdminVars/adminVarsSlice'
export default configureStore({
  reducer: {
    callDetails: callDetailsSlice,
    adminVars: adminVarSlice,
  },
})